import React, { useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";

const CODES = ["+91", "+1", "+44", "+61", "+971"];

export default function PhoneSearch({ onResult, compact }) {
  const [code, setCode] = useState("+91");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [captcha, setCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);

  const search = async () => {
    if (phone.replace(/\D/g, "").length < 8) return toast.error("Enter a valid mobile number");
    if (!captcha) return toast.error("Please confirm you are not a robot");
    if (!consent) return toast.error("Please accept the search disclaimer");
    setLoading(true);
    try {
      const res = await api.post("/search/phone", { phone: `${code}${phone.replace(/\D/g, "")}`, consent });
      onResult({ ...res.data, _searched_phone: `${code}${phone.replace(/\D/g, "")}` });
      toast.success("Search complete");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Search failed");
    }
    setLoading(false);
  };

  return (
    <div className={`rounded-2xl bg-white border border-slate-200 shadow-lg ${compact ? "p-4" : "p-5 sm:p-6"}`} data-testid="phone-search">
      <div className="flex flex-col sm:flex-row gap-2">
        <Select value={code} onValueChange={setCode}>
          <SelectTrigger className="sm:w-24" data-testid="search-country-code"><SelectValue /></SelectTrigger>
          <SelectContent>{CODES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Input
          data-testid="mobile-search-input"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Enter a verified mobile number to check available dispute information"
          className="flex-1"
        />
        <Button onClick={search} disabled={loading} data-testid="phone-search-btn" className="bg-teal-brand hover:bg-teal-700 text-white sm:w-auto">
          <Search className="h-4 w-4 mr-2" /> {loading ? "Searching…" : "Search"}
        </Button>
      </div>
      <div className="mt-3 space-y-2">
        <label className="flex items-center gap-2 text-xs text-slate-600">
          <Checkbox checked={captcha} onCheckedChange={setCaptcha} data-testid="captcha-check" />
          <span>I'm not a robot (abuse prevention)</span>
        </label>
        <label className="flex items-start gap-2 text-xs text-slate-600">
          <Checkbox checked={consent} onCheckedChange={setConsent} data-testid="search-consent-check" className="mt-0.5" />
          <span>
            I understand results may be incomplete and do not establish guilt. This is not a criminal record, credit
            report, or legal judgment. I will use this information responsibly.
          </span>
        </label>
      </div>
    </div>
  );
}
